import {Component, Input} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {Grossempfaengeradresse} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
  selector: 'common-ui-grossempfaengeradresse',
  templateUrl: './grossempfaengeradresse.component.html'
})
export class GrossempfaengeradresseComponent extends FormBaseComponent<Grossempfaengeradresse> {

  @Input()
  public showGrossempfaengerAdresse: boolean;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              private readonly translateService: TranslateService,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      ort: [this.data.ort, [
        this.validatorService.required(),
        this.validatorService.maxLength(72),
        this.validatorService.pattern('^[^\\d]*$',
          this.translateService.instant('COMMON_UI.VALIDATION.ORT_INVALID_PATTERN'))
      ]],
      postleitzahl: [this.data.postleitzahl, [
        this.validatorService.required(),
        this.validatorService.pattern('^[0-9]{5,5}$',
          this.translateService.instant('COMMON_UI.VALIDATION.PLZ_INVALID_PATTERN'))
      ]]
    });
  }
}
